var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "user",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.499,
    height: 21,
    viewBox: "0 0 16.499 21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_16",
    "data-name": "Path 16",
    d: "M7.5,6A4.5,4.5,0,1,1,12,10.5,4.5,4.5,0,0,1,7.5,6ZM3.751,20.1a8.25,8.25,0,1,1,16.5,0,.75.75,0,0,1-.438.695,18.8,18.8,0,0,1-15.624,0,.75.75,0,0,1-.437-.695Z",
    transform: "translate(-3.751 -1.5)",
    fill: "#5f6266",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.2c55c11af72e643d40c5a4e61a684848.svg";
export { ForwardRef as ReactComponent };